/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GatewayPaymentSumReport } from '../models/GatewayPaymentSumReport';
import type { GetGatewayPaymentQRResponse } from '../models/GetGatewayPaymentQRResponse';
import type { PaginatedAdminGatewayPaymentDto } from '../models/PaginatedAdminGatewayPaymentDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminGatewayPaymentService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PaginatedAdminGatewayPaymentDto OK
     * @throws ApiError
     */
    public reportTransactions({
        type,
        page,
        limit,
        from,
        to,
        sortBy,
        direction,
        shopId,
        search,
    }: {
        type: 'ALL' | 'DOWN_SAVING' | 'LOAN',
        page: number,
        limit: number,
        from?: string,
        to?: string,
        sortBy?: string,
        direction?: string,
        shopId?: string,
        search?: string,
    }): CancelablePromise<PaginatedAdminGatewayPaymentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/admin/gateway-payment/report/transactions',
            query: {
                'from': from,
                'to': to,
                'type': type,
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'direction': direction,
                'shopId': shopId,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GatewayPaymentSumReport OK
     * @throws ApiError
     */
    public reportSum({
        from,
        to,
        shopId,
        search,
    }: {
        from?: string,
        to?: string,
        shopId?: string,
        search?: string,
    }): CancelablePromise<GatewayPaymentSumReport> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/admin/gateway-payment/report/sum',
            query: {
                'from': from,
                'to': to,
                'shopId': shopId,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns GetGatewayPaymentQRResponse OK
     * @throws ApiError
     */
    public getQr1({
        gatewayPaymentId,
    }: {
        gatewayPaymentId: string,
    }): CancelablePromise<GetGatewayPaymentQRResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/admin/gateway-payment/qr/{gatewayPaymentId}',
            path: {
                'gatewayPaymentId': gatewayPaymentId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
